// กล่องอัปโหลด — เลือกไฟล์หรือลากมาวางก็ได้ อัปได้หลายไฟล์ต่อครั้ง
//
// ไฟล์ถูกส่งทีละไฟล์ตามลำดับ ไม่ยิงพร้อมกัน เพราะแต่ละไฟล์ใหญ่ได้ถึง 50MB
// ยิงพร้อมกันหลายไฟล์แล้วเน็ตออฟฟิศจะตันและ error รวมกันอ่านไม่รู้เรื่อง
import { useRef, useState } from "react";
import { IconUpload } from "@shared/ui/icons";
import { cn } from "@shared/lib/utils";

/** ต้องตรงกับ DOCUMENT_MAX_BYTES ฝั่ง server (server/config/constants.ts) */
export const MAX_UPLOAD_MB = 50;

export function UploadBox({
  disabled,
  hint,
  onFiles,
}: {
  disabled: boolean;
  hint: string;
  /** คืน error ของไฟล์ที่ล้มเหลว (ถ้ามี) เพื่อให้กล่องนี้แสดงให้ผู้ใช้เห็น */
  onFiles: (files: File[]) => Promise<string[]>;
}) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const [errors, setErrors] = useState<string[]>([]);

  async function take(list: FileList | null) {
    if (!list || disabled) return;
    const all = Array.from(list);
    // กันไว้ที่นี่ด้วยเพื่อไม่ต้องอัปโหลดขึ้นไปให้ server ปฏิเสธทีหลัง (เสียเวลาผู้ใช้เปล่า ๆ)
    const tooBig = all.filter((f) => f.size > MAX_UPLOAD_MB * 1024 * 1024);
    const ok = all.filter((f) => f.size <= MAX_UPLOAD_MB * 1024 * 1024 && f.size > 0);
    const empty = all.filter((f) => f.size === 0);

    const failed = ok.length ? await onFiles(ok) : [];
    setErrors([
      ...tooBig.map((f) => `${f.name} — ใหญ่เกิน ${MAX_UPLOAD_MB}MB`),
      ...empty.map((f) => `${f.name} — ไฟล์ว่าง`),
      ...failed,
    ]);
    if (inputRef.current) inputRef.current.value = "";
  }

  return (
    <div>
      <div
        className={cn("doc-drop", over && "on", disabled && "off")}
        onDragOver={(e) => {
          e.preventDefault();
          if (!disabled) setOver(true);
        }}
        onDragLeave={() => setOver(false)}
        onDrop={(e) => {
          e.preventDefault();
          setOver(false);
          void take(e.dataTransfer.files);
        }}
      >
        <IconUpload size={22} />
        <div>
          <strong>ลากไฟล์มาวาง หรือ</strong>{" "}
          <button
            type="button"
            className="btn-outline inline-btn"
            disabled={disabled}
            onClick={() => inputRef.current?.click()}
          >
            เลือกไฟล์
          </button>
          <div className="muted doc-drop-hint">{hint}</div>
        </div>
        <input
          ref={inputRef}
          type="file"
          multiple
          hidden
          onChange={(e) => void take(e.target.files)}
        />
      </div>

      {!!errors.length && (
        <ul className="doc-errors">
          {errors.map((msg, i) => (
            <li key={i}>{msg}</li>
          ))}
        </ul>
      )}
    </div>
  );
}
